module.exports = __webpack_public_path__ + "media/auto_main_information/zlodziej-b48b7fda.svg";